import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar, User, CreditCard } from 'lucide-react';
import { useReservationContext } from '../../../hooks/useReservationComms';
import CommunicationTimeline from './CommunicationTimeline';
import SendNowDropdown from './SendNowDropdown';
import ContextPanel from './ContextPanel';

function ReservationDetail() {
  const { reservationId } = useParams();
  const navigate = useNavigate();
  const { context, isLoading } = useReservationContext(reservationId);
  const [selectedSnapshot, setSelectedSnapshot] = useState(null); // eslint-disable-line no-unused-vars

  const handleBack = () => {
    navigate('/admin/email/queue');
  };

  const handleViewInQueue = () => {
    navigate(`/admin/email/queue?reservation=${reservationId}`);
  };

  if (isLoading) {
    return (
      <div className="reservation-detail-loading">
        <div>Loading reservation details...</div>
      </div>
    );
  }

  if (!context) {
    return (
      <div className="reservation-detail-error">
        <div>Reservation not found</div>
        <button className="btn btn-secondary" onClick={handleBack}>
          Back to Queue
        </button>
      </div>
    );
  }

  return (
    <div className="reservation-detail">
      <div className="reservation-detail-header">
        <button className="reservation-detail-back-btn" onClick={handleBack}>
          <ArrowLeft size={16} />
          Back to Queue
        </button>
        <h1>Reservation {reservationId}</h1>
        <div className="reservation-detail-spacer"></div>
      </div>

      <div className="reservation-detail-layout">
        <div className="reservation-detail-left">
          {/* Summary Card */}
          <div className="reservation-summary-card">
            <div className="reservation-summary-row">
              <div className="reservation-summary-field">
                <User size={16} className="reservation-summary-icon" />
                <div>
                  <div className="reservation-summary-label">Guest</div>
                  <div className="reservation-summary-value">
                    {context.customer?.firstName} {context.customer?.lastName}
                  </div>
                  <div className="reservation-summary-secondary">{context.customer?.email}</div>
                </div>
              </div>

              <div className="reservation-summary-field">
                <Calendar size={16} className="reservation-summary-icon" />
                <div>
                  <div className="reservation-summary-label">Dates</div>
                  <div className="reservation-summary-value">
                    {context.reservation?.checkIn} → {context.reservation?.checkOut}
                  </div>
                  <div className="reservation-summary-secondary">
                    {context.reservation?.nights} nights
                  </div>
                </div>
              </div>

              <div className="reservation-summary-field">
                <CreditCard size={16} className="reservation-summary-icon" />
                <div>
                  <div className="reservation-summary-label">Payment</div>
                  <div className="reservation-summary-value">
                    <span className={`reservation-status-badge reservation-payment-${context.payment?.status}`}>
                      {context.payment?.status}
                    </span>
                  </div>
                  <div className="reservation-summary-secondary">
                    {context.payment?.amount} {context.payment?.currency}
                  </div>
                </div>
              </div>
            </div>

            <div className="reservation-summary-actions">
              <button className="btn btn-secondary btn-sm" onClick={handleViewInQueue}>
                View in Queue
              </button>
            </div>
          </div>

          {/* Timeline Section */}
          <div className="reservation-timeline-section">
            <div className="reservation-timeline-header">
              <h2>Communication History</h2>
              <SendNowDropdown reservationId={reservationId} context={context} />
            </div>

            <CommunicationTimeline
              reservationId={reservationId}
              onSendClick={() => {
                // This could trigger the send dropdown to open
              }}
            />
          </div>
        </div>

        <div className="reservation-detail-right">
          <ContextPanel
            context={context}
            snapshot={selectedSnapshot}
            mode={selectedSnapshot ? 'snapshot' : 'live'}
          />
        </div>
      </div>
    </div>
  );
}

export default ReservationDetail;
